import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta7({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['d) Identificar las causas del conflicto.', 'b) Escuchar las perspectivas de las partes involucradas.', 'a) Facilitar un acuerdo común.', 'c) Dar seguimiento a la implementación del acuerdo.']);
	const [paso1, setPaso1] = useState(null);
	const [paso2, setPaso2] = useState(null);
	const [paso3, setPaso3] = useState(null);
	const [paso4, setPaso4] = useState(null);
	const [pasos, setPasos] = useState(1);

	const grabarSeleccionada = (opc, btn) => {
		const array = seleccionadas;
		array.push(opc);
		setSeleccionada(array);
		setPasos(pasos + 1);

		if (btn === 1) {
			setPaso1(pasos);
		}
		if (btn === 2) {
			setPaso2(pasos);
		}
		if (btn === 3) {
			setPaso3(pasos);
		}
		if (btn === 4) {
			setPaso4(pasos);
		}
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta7', seleccionadas, 1);
			sumarPuntos(1);
		} else {
			setRespuesta('pregunta7', seleccionadas, 0);
			sumarPuntos(0);
		}
		cambiarPregunta(8);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>7.</div> Ordena los pasos para resolver un conflicto en el equipo desde una gestión remota
						</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn1(true);
								grabarSeleccionada('a) Facilitar un acuerdo común.', 1);
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Facilitar un acuerdo común.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso1}</div>
					</Grid>

					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn2(true);
								grabarSeleccionada('b) Escuchar las perspectivas de las partes involucradas.', 2);
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Escuchar las perspectivas de las partes involucradas.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso2}</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn3(true);
								grabarSeleccionada('c) Dar seguimiento a la implementación del acuerdo.', 3);
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Dar seguimiento a la implementación del acuerdo.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso3}</div>
					</Grid>
					<Grid item xs={11} sm={11} md={11} lg={11}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn4(true);
								grabarSeleccionada('d) Identificar las causas del conflicto.', 4);
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'> Identificar las causas del conflicto.</div>
						</div>
					</Grid>
					<Grid item xs={1} sm={1} md={1} lg={1}>
						<div className='num-pregunta'>{paso4}</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
